/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_TitleInputs */

const en_common_error_title = /** @type {(inputs: Common_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oops`)
};

/**
* | output |
* | --- |
* | "Oops" |
*
* @param {Common_Error_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_error_title = /** @type {((inputs?: Common_Error_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_error_title(inputs)
});
export { common_error_title as "common.error.title" }